import { CategoryID, type Badge } from '@sbt-web/network/types';

export const filterBadgesByCategory = (
  data: Badge[] = [],
  categoryId?: CategoryID | null
) => {
  // No filter -> show all
  if (!categoryId) {
    return data;
  }

  return data.filter((badge) => {
    const categories = badge?.categories;

    // No badge categories -> show
    if (!categories) {
      return true;
    }

    // If categories is an array, check if it includes categoryId
    if (Array.isArray(categories)) {
      return categories.includes(categoryId);
    }

    // For any other type, don't show the badge
    return false;
  });
};
